import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TauriImage from "../../../TauriImage/TauriImage";
import "./TauriDatePickerCoverage.css";
import { getAll } from "../../../../localDB";
import { activityClassification, sessionType, statusMapping, SyncStatusMap } from "../../../../visualizations/visualizations";

const TauriDatePickerCoverage = ({ selectedDate, setSelectedDate, cyclePeriod }) => {
    const [sessionDates, setSessionDates] = useState([]);

    // Ensure the default date is set correctly with UTC+8 consideration
    const getTodayWithTimezoneOffset = () => {
        const now = new Date();
        now.setHours(0, 0, 0, 0); // Ensuring time does not affect date selection
        return now;
    };

    const handleDateChange = (date) => {
        if (!date) return;

        date.setHours(0, 0, 0, 0); // Ensure correct day is maintained
        setSelectedDate(date);
    };

    const handlePrev = () => {
        setSelectedDate((prev) => {
            const newDate = new Date(prev);
            newDate.setDate(newDate.getDate() - 1);
            newDate.setHours(0, 0, 0, 0); // Prevent timezone shifts
            return newDate;
        });
    };

    const handleNext = () => {
        setSelectedDate((prev) => {
            const newDate = new Date(prev);
            newDate.setDate(newDate.getDate() + 1);
            newDate.setHours(0, 0, 0, 0); // Prevent timezone shifts
            return newDate;
        });
    };

    const isToday = (date) => {
        const today = getTodayWithTimezoneOffset();
        return date.getTime() === today.getTime();
    };

    const fetchSessions = async () => {
        try {
            const cycle_id = localStorage.getItem("c_id");
            const sessions = await getAll("session");

            const currentDate = new Date().toLocaleDateString("en-CA");
            
            const result = sessions.filter(a =>
                a.CyclePeriodID === Number(cycle_id) &&
                a.Tag == null &&
                ![sessionType.Incidental, sessionType.ApprovedMissedCall].includes(a.Type) &&
                [statusMapping.pending, statusMapping.inprogress].includes(a.Status) &&
                a.Activity?.Classification != activityClassification.Event &&
                a.SessionDate <= currentDate &&
                a.SyncStatus !== SyncStatusMap.done
            );

            const uniqueSessionDates = [...new Set(
                result
                    .map(session => session.SessionDate)
                    .filter(Boolean) // Remove null/undefined if any
            )];

            setSessionDates(uniqueSessionDates || []);
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        fetchSessions();
    }, [selectedDate])

    return (
        <div className="tauri-datepicker-coverage px-3">
            <div className="tauri-datepicker-coverage-range d-flex align-items-center justify-content-center">
                {cyclePeriod?.Code} - {cyclePeriod?.Description}
            </div>

            <div className="tauri-datepicker-coverage-display d-flex align-items-center justify-content-between w-100">
                <TauriImage localImage="/Images/arrow-left.svg" alt="arrow-left" onClick={handlePrev} className="dt-arrowleft" />

                <DatePicker
                    selected={selectedDate}
                    onChange={handleDateChange}
                    dateFormat="EEEE, MMMM d"
                    dayClassName={(date) => {
                        const key = date.toLocaleDateString("en-CA"); 
                        return sessionDates.includes(key) ? "pending-session" : "";
                    }}
                    customInput={
                        <div className="datepicker-input">
                            <span className="datepicker-text">
                                {isToday(selectedDate)
                                    ? `Today, ${selectedDate.toLocaleDateString("en-US", { month: "long", day: "numeric" })}`
                                    : selectedDate.toLocaleDateString("en-US", {
                                        weekday: "long",
                                        month: "long",
                                        day: "numeric",
                                    })}
                            </span>
                            <TauriImage localImage="/Images/arrow-down.svg" alt="arrow-down" className="dt-arrowdown" color={"#000"} />
                        </div>
                    }
                />

                <TauriImage localImage="/Images/arrow-right.svg" alt="arrow-right" onClick={handleNext} className="dt-arrowright" />
            </div>
        </div>
    );
};

export default TauriDatePickerCoverage;
